export default __webpack_public_path__ + "static/media/38.8520011f.jpeg";